import React from 'react';
import { withTranslation } from 'react-i18next';
import ReactPasswordStrength from 'react-password-strength';
import { PASSWORD_MAX_LENGTH } from '../../utils/helper';
import { Container } from './styles';
import { PASSWORD_STRENGTH_BAR } from './translationValues';

const NAMESPACES = ['PASSWORD_STRENGTH_BAR'];

const PasswordStrengthBar = (props) => {
  const { onChangeScore, t } = props;

  const preventAction = (e) => {
    e.preventDefault(); // Prevent the default paste behavior
  }

  return (
    <Container>
     <ReactPasswordStrength
      className="customClass"
      minLength={0}
      minScore={4}
      scoreWords={[t(PASSWORD_STRENGTH_BAR.SHORT_PASSWORD_STRENGTH.key, PASSWORD_STRENGTH_BAR.SHORT_PASSWORD_STRENGTH.value),t(PASSWORD_STRENGTH_BAR.WEAK_PASSWORD_STRENGTH.key, PASSWORD_STRENGTH_BAR.WEAK_PASSWORD_STRENGTH.value), t(PASSWORD_STRENGTH_BAR.FAIR_PASSWORD_STRENGTH.key, PASSWORD_STRENGTH_BAR.FAIR_PASSWORD_STRENGTH.value), t(PASSWORD_STRENGTH_BAR.GOOD_PASSWORD_STRENGTH.key, PASSWORD_STRENGTH_BAR.GOOD_PASSWORD_STRENGTH.value), t(PASSWORD_STRENGTH_BAR.STRONG_PASSWORD_STRENGTH.key, PASSWORD_STRENGTH_BAR.STRONG_PASSWORD_STRENGTH.value)]}
      changeCallback={onChangeScore}
      inputProps={{ maxLength:PASSWORD_MAX_LENGTH,onPaste: (e) => { preventAction(e) }, onCopy: (e) => { preventAction(e) }, name: 'password_input', autoComplete: 'new-password', className: 'form-control', placeholder: t(PASSWORD_STRENGTH_BAR.USER_PASSWORD_PLACEHOLDER.key, PASSWORD_STRENGTH_BAR.USER_PASSWORD_PLACEHOLDER.value) }}
    />
    </Container>

  );
};

export default withTranslation(NAMESPACES)(PasswordStrengthBar);
